export enum EventTypeEnum {
    MEAL = 'meal',
    HOMEWORK = 'homework',
}
